<template>
	<div class="app">
		<component :is="layout" :key="layout">
			<router-view/>
		</component>
		<notify/>
	</div>
</template>

<script>
import l_base from "@/components/layouts/base.vue";
import l_main from "@/components/layouts/main.vue";
import notify from "@/components/notify.vue";

export default {
	components: {notify, l_base, l_main},
	computed: {
		routeLayout: (t) => t.$route.meta.layout || "base",
		layout: (t) => `l_${t.routeLayout}`
	}
};
</script>
<style lang="scss" scoped>
.app {
	min-height: 100vh;
}
</style>
